import { Component } from "react";

import { BTText } from "@btnet/core-components";

import { BdsEnrichedIcon } from "@buildertrend/components";

import { BTButton } from "commonComponents/btWrappers/BTButton/BTButton";
import { BTCol } from "commonComponents/btWrappers/BTCol/BTCol";
import { BTRow } from "commonComponents/btWrappers/BTRow/BTRow";
import { EmptyState } from "commonComponents/entity/emptyState/EmptyState";

interface IBillApprovalQueueEmptyStateProps {
    onBackToBills: () => void;
}

/**
 * Empty state component for the Bill Approval Queue.
 * Displayed when there are no bills awaiting approval by the current user.
 */
export class BillApprovalQueueEmptyState extends Component<IBillApprovalQueueEmptyStateProps> {
    render() {
        const { onBackToBills } = this.props;

        return (
            <EmptyState
                title="You're all caught up"
                image={
                    <BdsEnrichedIcon
                        iconName="GoalsInverted"
                        size="6xl"
                        testid="BillApprovalQueueEmptyStateIcon"
                    />
                }
            >
                <BTRow>
                    <BTCol xs={24}>
                        <BTText size="normal-md">
                            No bills are currently waiting for your approval.
                        </BTText>
                    </BTCol>
                </BTRow>
                <BTRow className="margin-top-lg">
                    <BTCol xs={24}>
                        <BTButton
                            type="primary"
                            onClick={onBackToBills}
                            data-testid="BackToBillsButton"
                        >
                            Back to Bills
                        </BTButton>
                    </BTCol>
                </BTRow>
            </EmptyState>
        );
    }
}
